// extracted by mini-css-extract-plugin
export default {"error":"salNfXvhC8qxHSL5f0kJ"};